const capitalsUS = [
  { prompt: "Alabama", answers: ['montgomery'] },
  { prompt: "Alaska", answers: ['juneau'] },
  { prompt: "Arizona", answers: ['phoenix'] },
  { prompt: "Arkansas", answers: ['little rock'] },
  { prompt: "California", answers: ['sacramento'] },
  { prompt: "Colorado", answers: ['denver'] },
  { prompt: "Connecticut", answers: ['hartford'] },
  { prompt: "Delaware", answers: ['dover'] },
  { prompt: "Florida", answers: ['tallahassee'] },
  { prompt: "Georgia", answers: ['atlanta'] },
  { prompt: "Hawaii", answers: ['honolulu'] },
  { prompt: "Idaho", answers: ['boise'] },
  { prompt: "Illinois", answers: ['springfield'] },
  { prompt: "Indiana", answers: ['indianapolis'] },
  { prompt: "Iowa", answers: ['des moines'] },
  { prompt: "Kansas", answers: ['topeka'] },
  { prompt: "Kentucky", answers: ['frankfort'] },
  { prompt: "Louisiana", answers: ['baton rouge'] },
  { prompt: "Maine", answers: ['augusta'] },
  { prompt: "Maryland", answers: ['annapolis'] },
  { prompt: "Massachusetts", answers: ['boston'] },
  { prompt: "Michigan", answers: ['lansing'] },
  { prompt: "Minnesota", answers: ['saint paul'] },
  { prompt: "Mississippi", answers: ['jackson'] },
  { prompt: "Missouri", answers: ['jefferson city'] },
  { prompt: "Montana", answers: ['helena'] },
  { prompt: "Nebraska", answers: ['lincoln'] },
  { prompt: "Nevada", answers: ['carson city'] },
  { prompt: "New Hampshire", answers: ['concord'] },
  { prompt: "New Jersey", answers: ['trenton'] },
  { prompt: "New Mexico", answers: ['santa fe'] },
  { prompt: "New York", answers: ['albany'] },
  { prompt: "North Carolina", answers: ['raleigh'] },
  { prompt: "North Dakota", answers: ['bismarck'] },
  { prompt: "Ohio", answers: ['columbus'] },
  { prompt: "Oklahoma", answers: ['oklahoma city'] },
  { prompt: "Oregon", answers: ['salem'] },
  { prompt: "Pennsylvania", answers: ['harrisburg'] },
  { prompt: "Rhode Island", answers: ['providence'] },
  { prompt: "South Carolina", answers: ['columbia'] },
  { prompt: "South Dakota", answers: ['pierre'] },
  { prompt: "Tennessee", answers: ['nashville'] },
  { prompt: "Texas", answers: ['austin'] },
  { prompt: "Utah", answers: ['salt lake city'] },
  { prompt: "Vermont", answers: ['montpelier'] },
  { prompt: "Virginia", answers: ['richmond'] },
  { prompt: "Washington", answers: ['olympia'] },
  { prompt: "West Virginia", answers: ['charleston'] },
  { prompt: "Wisconsin", answers: ['madison'] },
  { prompt: "Wyoming", answers: ['cheyenne'] }
];

const capitalsDE = [
  { prompt: "Baden-Württemberg", answers: ['stuttgart'] },
  { prompt: "Bavaria (Bayern)", answers: ['munich', 'münchen', 'munchen'] },
  { prompt: "Berlin", answers: ['berlin'] },
  { prompt: "Brandenburg", answers: ['potsdam'] },
  { prompt: "Bremen", answers: ['bremen'] },
  { prompt: "Hamburg", answers: ['hamburg'] },
  { prompt: "Hesse (Hessen)", answers: ['wiesbaden'] },
  { prompt: "Lower Saxony (Niedersachsen)", answers: ['hanover', 'hannover'] },
  { prompt: "Mecklenburg-Vorpommern", answers: ['schwerin'] },
  { prompt: "North Rhine-Westphalia (Nordrhein-Westfalen)", answers: ['düsseldorf', 'dusseldorf'] },
  { prompt: "Rhineland-Palatinate (Rheinland-Pfalz)", answers: ['mainz'] },
  { prompt: "Saarland", answers: ['saarbrücken', 'saarbrucken'] },
  { prompt: "Saxony (Sachsen)", answers: ['dresden'] },
  { prompt: "Saxony-Anhalt (Sachsen-Anhalt)", answers: ['magdeburg'] },
  { prompt: "Schleswig-Holstein", answers: ['kiel'] },
  { prompt: "Thuringia (Thüringen)", answers: ['erfurt'] }
];

export const categories = [
  {
    name: "US State Capitals",
    value: "us",
    questions: capitalsUS
  },
  {
    name: "German Bundesländer Capitals",
    value: "de",
    questions: capitalsDE
  }
]
